import R from 'ramda'

const LIKE_OF_ANY_DISPLAY_TYPE = 'Like Of Any'
const LIKE_OF_ANY_TRIGGER_TYPE = 'LIKE_OF_ANY'

const isLikeOfAnyFormTrigger = R.propEq('type', LIKE_OF_ANY_DISPLAY_TYPE)

const convertLikeAnyFormToWidgetTrigger = R.applySpec({
  type: R.always(LIKE_OF_ANY_TRIGGER_TYPE),
  data: R.prop('tweetIdList'),
  operator: R.always('AND'),
  primary: R.T
})

export { isLikeOfAnyFormTrigger, convertLikeAnyFormToWidgetTrigger }



// WEBPACK FOOTER //
// ./src/pages/widgets/mapping/triggers/twitter/form-to-widget/like_of_any.js